import { Injectable } from '@angular/core';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import * as actions from './actions';
import { IndexType } from '@fnModels/algolia/algolia';
import { getIndex } from '@state/utils/helper';
import { AlgoliaBaseState, AlgoliaSearchState } from '..';

export type FireInsuranceCompanySearchStateModel = AlgoliaBaseState<unknown>;

@State<FireInsuranceCompanySearchStateModel>({
	name: 'fireInsuranceCompaniesSearch',
	defaults: {
		searchTerm: '',
		searching: false,
		success: null,
		error: null,
		items: [],
	},
})
@Injectable()
export class FireInsuranceCompaniesSearchState extends AlgoliaSearchState<FireInsuranceCompanySearchStateModel> {
	protected indexName = getIndex(IndexType.FIRE_INSURANCE_COMPANIES);

	@Selector([FireInsuranceCompaniesSearchState])
	static getList(state: FireInsuranceCompanySearchStateModel): unknown[] {
		return state?.items;
	}

	@Action(actions.Search)
	async search(
		ctx: StateContext<FireInsuranceCompanySearchStateModel>,
		{ searchTerm }: actions.Search,
	): Promise<void> {
		await this.algoliaSearchHandler(ctx, searchTerm);
	}
}
